// Sprint 6-home-redesign: блок показателей ВНЕ НОРМЫ на Главной.
//
// HEAL-37: назывался «Требует внимания», но показывал 🔴. После HEAL-35 ровно эта
// фраза стала подписью оранжевого тира на карточке показателя — одно название на
// два разных статуса. Здесь остаются красные, а заголовок теперь говорит правду.
// Только 🔴 out_of_range (топ-3 по sortByTier). Позиция = СЛОВОМ «выше/ниже нормы»,
// БЕЗ стрелки (правило разведения: ↑↓ = только динамика, живёт в «Что изменилось»).
// >3 → «Показать все N →» ведёт в «Маркеры»/«По категориям»/фильтр «Вне нормы».

import { MarkerRow } from '@/components/dashboard/MarkerRow';
import { hasHistory } from '@/components/dashboard/HistoryHint';
import { attentionView } from '@/lib/homeAttention';
import type { DashboardBiomarkerItem } from '@/api/types';

export function AttentionList({
  items,
  onOpenMarker,
  onShowAll,
  bare = false,
}: {
  items: DashboardBiomarkerItem[];
  onOpenMarker: (code: string) => void;
  onShowAll: () => void;
  /**
   * Без собственного горизонтального отступа: на Главной блок лежит внутри
   * общей секции вместе с двумя входами в каталог и строкой «Без оценки» —
   * иначе отступ задвоился бы.
   */
  bare?: boolean;
}) {
  if (items.length === 0) return null;

  const { shown, total, hasMore } = attentionView(items);
  const Wrapper = bare ? 'div' : 'section';

  return (
    <Wrapper className={bare ? undefined : 'px-4'}>
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-hl-section font-bold text-foreground">Вне нормы</h2>
        <span className="rounded-full bg-bad/10 px-2 py-0.5 text-hl-small font-semibold text-bad-text">
          {total}
        </span>
      </div>

      <div className="space-y-2">
        {shown.map((item) => (
          <MarkerRow
            key={item.biomarker_code}
            variant="attention"
            name={item.canonical_name_ru}
            normalRangeLabel={item.normal_range_label}
            value={item.value_normalized}
            unit={item.unit_normalized}
            valueText={item.value_qualitative}
            clinicalStatus={item.clinical_status}
            optimumStatus={item.optimum_status}
            direction={item.direction}
            hasHistory={hasHistory(item.points_count)}
            onClick={() => onOpenMarker(item.biomarker_code)}
          />
        ))}
      </div>

      {hasMore && (
        <button
          type="button"
          onClick={onShowAll}
          className="mt-3 flex w-full items-center justify-center gap-1.5 rounded-surface border border-dashed border-border bg-muted py-2.5 text-hl-secondary font-semibold text-primary-text transition hover:border-primary hover:bg-primary/5"
        >
          Показать все {total} →
        </button>
      )}
    </Wrapper>
  );
}
